import { Link } from "react-router-dom";
import { Check, ArrowRight, Phone } from "lucide-react";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import EnquirySection from "../components/EnquirySection";
import { BUSINESS, SERVICES, GALLERY } from "../lib/constants";
import { usePageTitle } from "../lib/seo";

export default function Services() {
  usePageTitle("Services");
  return (
    <div>
      <PageHero
        eyebrow="Our Services"
        title="Everything Your Event Needs"
        sub="From grand wedding tents to the smallest detail of lighting and flowers — planned, delivered and cleared away by one dependable team."
        image={GALLERY[1].src}
      />

      <section className="mx-auto max-w-7xl space-y-8 px-5 py-20 sm:px-8 md:py-24">
        {SERVICES.map((s, i) => (
          <Reveal key={s.slug} className="h-full">
            <article
              className={`card-royal group grid overflow-hidden transition-all duration-500 hover:border-gold/40 md:grid-cols-2 ${
                i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""
              }`}
            >
              <div className="relative h-64 overflow-hidden md:h-auto md:min-h-[320px]">
                <img
                  src={s.image}
                  alt={s.title}
                  loading={i < 2 ? "eager" : "lazy"}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className={`absolute inset-0 bg-gradient-to-t md:bg-gradient-to-r ${i % 2 === 1 ? "md:bg-gradient-to-l" : ""} from-[#14120E] via-transparent to-transparent`} />
              </div>
              <div className="flex flex-col justify-center p-7 sm:p-10">
                <p className="font-accent text-xs uppercase tracking-[0.3em] text-gold">
                  {String(i + 1).padStart(2, "0")}
                </p>
                <h2 className="mt-3 font-display text-2xl font-semibold text-amber-100 sm:text-3xl">{s.title}</h2>
                <p className="mt-3 text-sm leading-relaxed text-stone-400 sm:text-base">{s.short}</p>
                <ul className="mt-5 grid gap-2 sm:grid-cols-2">
                  {s.features.map((f) => (
                    <li key={f} className="flex items-start gap-2 text-sm text-stone-300">
                      <Check className="mt-0.5 h-4 w-4 shrink-0 text-gold" /> {f}
                    </li>
                  ))}
                </ul>
                <div className="mt-7 flex flex-wrap gap-3">
                  <Link to={`/contact?service=${encodeURIComponent(s.title)}`} data-testid={`service-enquire-${s.slug}`} className="btn-gold !px-6 !py-2.5">
                    Enquire for this Service <ArrowRight className="h-4 w-4" />
                  </Link>
                  <a href={BUSINESS.phoneHref} data-testid={`service-call-${s.slug}`} className="btn-outline-gold !px-6 !py-2.5">
                    <Phone className="h-4 w-4" /> Call Now
                  </a>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </section>

      <EnquirySection />
    </div>
  );
}
